// extracted by mini-css-extract-plugin
module.exports = {"topNav":"TopNav_top-nav__3ZMPX","logoLink":"TopNav_logo-link__3Y23o","logo":"TopNav_logo__39ZOZ"};